module.exports = __webpack_public_path__ + "static/media/icon-chevron-down.6fd68a12.svg";